import { render, staticRenderFns } from "./OtherExpenseModal.vue?vue&type=template&id=98e171c8&"
import script from "./OtherExpenseModal.vue?vue&type=script&lang=js&"
export * from "./OtherExpenseModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports